import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ConfirmModal from '@/components/Modals/ConfirmModal.vue';
import useModals from '@/components/Modals/useModals';
import { ConfirmModalResponse } from '@/components/Modals/modals.types';
import { EModal } from '@/enums';
import paths from '@/router/paths';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'LogoutItem',
  setup(__props) {

const router = useRouter()
const { toggleModal } = useModals()

const handleLogout = () => {
    toggleModal(EModal.confirm)
}

const handleConfirmAction = (action: ConfirmModalResponse) => {
    if (action === 'confirm') {
        router.push(paths.login)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "list-group-item text-danger",
      onClick: handleLogout
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "row align-items-center" }, [
        _createElementVNode("div", { class: "col" }, [
          _createElementVNode("h4", { class: "mb-1" }, " Sair ")
        ])
      ], -1)
    ])),
    _createVNode(ConfirmModal, {
      title: "Sair",
      message: "Deseja deslogar de sua conta?",
      confirmText: "Sair",
      onOnAction: handleConfirmAction
    })
  ], 64))
}
}

})